<template>
  <!-- eslint-disable vue/max-attributes-per-line -->
  <section class="media media-loader">
    <!-- vue3-migration -- отсутствует компонент для slot="head" -->
    <div class="head-wrap">
      <div class="!tw-justify-between !tw-flex ml-8 mr-8 level-0">
        <div class="!tw-flex level-1">
          <div class="!tw-flex level-2">
            <Skeleton height="12px" width="163px" class="mr-12 mt-10 mb-0" />
          </div>
          <div class="!tw-flex level-2">
            <Skeleton height="34px" width="200px" class="mr-12" />
            <Skeleton height="34px" width="150px" class="mr-12" />
          </div>
        </div>
        <div class="!tw-flex level-1">
          <div class="!tw-flex level-2 ml-8">
            <Skeleton height="34px" width="153px" />
          </div>
          <div class="!tw-flex level-2 ml-12">
            <div>
              <Skeleton height="34px" width="80px" class="mr-12" />
              <Skeleton height="34px" width="212px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <Skeleton width="auto" class="mb-24 ml-24 mr-24" />
  </section>
</template>

<script>
import Skeleton from '@/components/Skeleton';

export default {
  components: {
    Skeleton,
  },
  created() {
    // vue3-migration -- вроде нигде не используется
    // this.name = this.$vnode.data.props.name;
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/media/media';
</style>
